<template>
  <div class="container">
    <!--UPLOAD-->
    <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving">
      <div class="dropbox">
        <input type="file" name="document" :disabled="isSaving" @change="processFile" class="input-file" />
        <p v-if="isInitial">
          Drag your file(s) here to begin<br />
          or click to browse
        </p>
        <p v-if="isSaving">
          Uploading files...
        </p>
      </div>
    </form>
    <!--SUCCESS-->
    <div v-if="isSuccess">
      <h2>Uploaded file successfully.</h2>
      <p>
        <a href="javascript:void(0)" @click="reset()">Upload again</a>
      </p>
    </div>
    <!--FAILED-->
    <div v-if="isFailed">
      <h2>Uploaded failed.</h2>
      <p>
        <a href="javascript:void(0)" @click="reset()">Try again</a>
      </p>
      <pre>{{ uploadError }}</pre>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import document from '../../../../api/documents';
import { mapActions } from 'vuex';

const STATUS_INITIAL = 0;
const STATUS_SAVING = 1;
const STATUS_SUCCESS = 2;
const STATUS_FAILED = 3;

export default {
  name: 'multi-file-upload',
  props: ['url', 'customer', 'referral'],
  data() {
    return {
      uploadError: null,
      currentStatus: null
    };
  },
  computed: {
    isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },
    isSuccess() {
      return this.currentStatus === STATUS_SUCCESS;
    },
    isFailed() {
      return this.currentStatus === STATUS_FAILED;
    }
  },
  methods: {
    ...mapActions(['getDocuments', 'getReferralDocuments']),
    reset() {
      this.currentStatus = STATUS_INITIAL;
      this.uploadError = null;
    },

    processFile: function(element) {
      const files = element.target.files;
      if (!files[0]) {
        return;
      }
      const customerID = _.isNull(this.customer) ? null : this.customer.id;
      const referralID = _.isNull(this.referral) ? null : this.referral.id;
      document
        .upload(files, customerID, referralID)
        .then(response => {
          this.currentStatus = STATUS_SUCCESS;
          if (!_.isNull(this.customer)) {
            this.getDocuments(customerID);
          } else if (!_.isUndefined(referralID)) {
            this.getReferralDocuments(referralID);
          } else {
            this.$emit('uploaded', { url: response.url, file_name: files[0].name });
          }
        })
        .catch(err => {
          this.uploadError = err.response;
          this.currentStatus = STATUS_FAILED;
        });
    }
  },
  mounted() {
    this.reset();
  }
};
</script>

<style lang="scss">
.dropbox {
  outline: 2px dashed grey; /* the dash box */
  outline-offset: -10px;
  background: lightcyan;
  color: dimgray;
  padding: 10px 10px;
  min-height: 200px; /* minimum height */
  position: relative;
  cursor: pointer;
}

.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}

.dropbox:hover {
  background: lightblue; /* when mouse over to the drop zone, change color */
}

.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}
</style>
